/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OverlayGrid/view.blocks to change it.
import HorizontalGuideLines from './HorizontalGuideLines/index'
import React from 'react'
import VerticalGuideLines from './VerticalGuideLines/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OverlayGrid({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/OverlayGrid"
  
}) {
  return (<React.Fragment
>
<HorizontalGuideLines
  viewPath={`${viewPath}/HorizontalGuideLines`}
/>
<VerticalGuideLines
  viewPath={`${viewPath}/VerticalGuideLines`}
/>
{children}
</React.Fragment>)
}